import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride(['moduleName', 'pretitle', 'title', 'subtitle', 'primaryText', 'secondaryText', 'additionalDetailTitle', 'additionalDetailItems', 'attachmentButtonText'], {
    hidden: true,
  });
